import React from 'react';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    enableAnimation,
    orientation,
    spacing = 3
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    return {
      root: {
        display: 'flex',
        flexDirection: orientation === 'horizontal' ? 'row' : 'column',
        [enableAnimation ? '[data-group-spacing="true"]' : '> *:not(:last-of-type)']: {
          [orientation === 'horizontal' ? 'marginRight' : 'marginBottom']: theme.layout["size".concat(spacing)] || 0
        }
      }
    };
  }, [enableAnimation, orientation, spacing, theme]);
};
export default useStyles;